export default __webpack_public_path__ + "static/media/save.777a2453.svg";